import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'uni-date-range-filter',
  templateUrl: './date-range-filter.component.html',
  styleUrls: ['./date-range-filter.component.scss'],
  providers: [DatePipe]
})

export class DateRangeFilterComponent implements OnInit {

  @Input() selectedRange: string = '';
  @Input() startDate: string = '';
  @Input() endDate: string = '';
  @Input() placeholder: string = '';
  @Input() customClass: string = '';
  param: string;

  date = new Date();
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  @Input() filterOptions = [];
  @Output() dateRangeOutput = new EventEmitter<any>();

  constructor(private datePipe: DatePipe) {
    if (!this.filterOptions.length) {
      const dateToday = this.datePipe.transform(this.date, 'yyyy-MM-dd');
      const year = this.date.getFullYear();
      const month = this.date.getMonth();
      const dayOfMonth = this.date.getDate();
      const firstDayOfWeek = this.date.getDate() - this.date.getDay() + 1;
      const lastDayOfWeek = firstDayOfWeek + 6;
      const firstDayOfLastWeek = firstDayOfWeek - 7;
      const lastDayOfLastWeek = firstDayOfWeek - 1;

      this.filterOptions = [
        {
          name: 'Today',
          startDate: dateToday,
          endDate: dateToday
        },
        {
          name: 'Yesterday',
          startDate: new Date(year, month, dayOfMonth - 1),
          endDate: new Date(year, month, dayOfMonth - 1)
        },
        {
          name: 'This Week',
          startDate: new Date(this.date.setDate(firstDayOfWeek)),
          endDate: new Date(this.date.setDate(lastDayOfWeek))
        },
        {
          name: 'Last Week',
          startDate: new Date(this.date.setDate(firstDayOfLastWeek)),
          endDate: new Date(this.date.setDate(lastDayOfLastWeek))
        },
        {
          name: 'This Month',
          startDate: new Date(year, month, 1),
          endDate: new Date(year, month + 1, 0)
        },
        {
          name: 'Last Month',
          startDate: new Date(year, month - 1, 1),
          endDate: new Date(year, month, 0)
        },
        {
          name: 'This Year',
          startDate: new Date(year, 0, 1),
          endDate: new Date(year, 11, 31)
        },
        {
          name: 'Last Year',
          startDate: new Date(year - 1, 0, 1),
          endDate: new Date(year - 1, 11, 31)
        },
        { name: 'Custom' },
      ];
    }
  }

  ngOnInit() {
    this.range.get('start').setValue(this.startDate);
    this.range.get('end').setValue(this.endDate);
  }

  setDefaultDateRange(option: any) {
    this.param = option.param ? option.param : null;
    if (option.name != 'Custom') {
      this.range.reset();
      this.setDateRange(option.startDate, option.endDate, 'Default');
    }
  }

  setDateRange(startDate, endDate, searchType?: string) {
    if ((searchType == 'Custom' && this.range.valid) || searchType == 'Default') {
      const modifiedStartDate = this.datePipe.transform(startDate, 'yyyy-MM-dd');
      const modifiedEndDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');

      const result = {
        startDate: modifiedStartDate,
        endDate: modifiedEndDate,
        selectedRange: this.selectedRange,
        placeholder: this.placeholder,
        param: this.param
      };

      this.dateRangeOutput.emit(result);
    }
  }
}
